// Generated by scripts/build-ui-icons.mjs.
export { BookOpen as default } from "../ui/glyphs-1";
